// extracted by extract-css-chunks-webpack-plugin
module.exports = {"disabled":"input__disabled--3M_Tw"};